import { render, staticRenderFns } from "./DisplayAssignedModuleLmsElement.vue?vue&type=template&id=50d1de85&scoped=true&"
import script from "./DisplayAssignedModuleLmsElement.vue?vue&type=script&lang=ts&"
export * from "./DisplayAssignedModuleLmsElement.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayAssignedModuleLmsElement.vue?vue&type=style&index=0&id=50d1de85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1de85",
  null
  
)

/* custom blocks */
import block0 from "./DisplayAssignedModuleLmsElement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VProgressCircular,VRow,VSheet})
